<template>
    <div>
        <div id="timelino" v-chat-scroll="{always: true, smooth: true, notSmoothOnInit: true, scrollonremoved:true}">
        <v-timeline>
            <v-slide-x-reverse-transition group>

                <div v-for="row in $store.getters['chat/getMessageByContract'](contract_id)" :key="row.id" :data-id="row.id">
                    <v-timeline-item v-if="isAnotherDay(row.published_date, row.contract_id)" class="my-4 divider" hide-dot>
                        <v-chip>{{ getFormatedDate(row.published_date) }}</v-chip>
                    </v-timeline-item>
                    
                    <v-timeline-item
                        :left="row.sender==='user'" 
                        :right="row.sender!=='user'" 
                        :color="row.color ? row.color : 'grey'" 
                        :icon="row.icon ? row.icon : 'settings'" 
                        :small="(row.sender==='user' || row.sender==='support') ? false : true" 
                        :large="row.sender==='user' || row.sender==='support'"
                    >
                        <ProfilAvatar v-if="row.sender==='user'" slot="icon" />
                        <v-avatar v-if="row.sender==='support'" color="red" slot="icon" :title="getWorkerName(row.sender_name)"><img :src="getWorkerPicture(row.sender_name)" :alt="row.sender_name" /></v-avatar>
                        <span slot="opposite">
                            <v-badge v-if="((row.is_readed===false || row.is_readed=='false') && row.sender!=='user')" color="white" :left="row.sender==='user'">
                                <v-icon slot="badge" color="black" dark style="font-size: 1.5rem">fiber_new</v-icon>
                                <span><div v-if="row.sender==='support'">{{ getWorkerName(row.sender_name) }}</div>{{ row.published_date | moment("HH:mm") }} Uhr</span>
                            </v-badge>
                            <span v-else><div v-if="row.sender==='support'">{{ getWorkerName(row.sender_name) }}</div>{{ row.published_date | moment("HH:mm") }} Uhr</span>
                        </span>

                        <div v-if="row.sender==='system'" class="text-xs-right">
                            <div v-if="row.content" class="pr-5 white--text">
                                <span v-html="row.content"></span>
                            </div>
                            <router-link v-if="row.contract_id!=='system'" :to="'/contract/'+row.contract_id" class="opencontractchatlink chatlink-box" title="Vertrag öffnen"><v-icon right>open_in_new</v-icon></router-link>
                            <router-link v-if="row.type==='settings'" to="/settings" class="opencontractchatlink chatlink-box" title="Meine Daten öffnen"><v-icon right>open_in_new</v-icon></router-link>
                            <router-link v-if="row.type==='accountsettings'" to="/accountsettings" class="opencontractchatlink chatlink-box" title="Benutzerkonto-Einstellungen öffnen"><v-icon right>open_in_new</v-icon></router-link>
                            <router-link v-if="row.content && row.type==='mandate' || row.type==='businessdoc'" to="/documents" class="opencontractchatlink chatlink-box" title="Dokumente aufrufen"><v-icon right>open_in_new</v-icon></router-link>
                        </div>

                        <v-card v-else class="pa-2">
                            <img v-if="row.file_type=='image'" :src="row.file_url" alt="" style="max-width:100%;max-height:500px;" @click="getInfoModal(row)" />
                            <a v-if="row.file_type=='pdf'" :href="row.file_url" target="_blank" :download="row.file_name" color="white" class="text-xs-center pt-3" style="height:150px;">
                                <v-img :src="require('@/assets/images/pdf_icon.svg')" height="125px" alt="" style="width:auto;" class="" contain></v-img>
                            </a>
                            <div v-if="row.file_type=='wav' || row.file_type=='mp3'" style="min-height: 4.5rem;display: flex;">
                                <audio controls :src="row.file_url" style="width:100%;"></audio>
                            </div>
                            <v-progress-linear v-if="row.progress"
                                :value="row.progress"
                                height="5"
                                color="black"
                                style="margin: -6px 0 0;"
                            ></v-progress-linear>
                            <div v-if="row.content" class="py-2 pr-5">
                                <span v-html="row.content"></span>
                            </div>
                            <router-link v-if="!row.link && row.content && row.type==='settings' && row.sender=='support' && row.contract_id=='system'" to="/settings" class="opencontractchatlink chatlink-box" title="Meine Daten öffnen"><v-icon>open_in_new</v-icon></router-link>
                            <router-link v-if="!row.link && row.content && (row.type==='settings' || row.type==='message') && row.sender=='support' && row.contract_id!='system'" :to="'/contract/'+row.contract_id" class="opencontractchatlink chatlink-box" title="Vertrag öffnen"><v-icon>open_in_new</v-icon></router-link>
                            <router-link v-if="!row.link && row.content && row.type==='mandate' || row.type==='businessdoc'" to="/documents" class="opencontractchatlink chatlink-box" title="Dokumente aufrufen"><v-icon>open_in_new</v-icon></router-link>
                            <!-- <router-link v-if="row.link" :to="row.link" class="opencontractchatlink chatlink-box" title="Link öffnen"><v-icon>open_in_new</v-icon></router-link> -->
                            <router-link v-if="row.link && row.link[0]=='/'" :to="row.link" class="opencontractchatlink chatlink-box" title="Link öffnen"><v-icon>open_in_new</v-icon></router-link>
                            <a v-if="row.link && row.link[0]!='/'" :href="row.link" target="_blank" class="opencontractchatlink chatlink-box" title="Link öffnen"><v-icon>open_in_new</v-icon></a>
                        </v-card>
                    </v-timeline-item>
                </div>
                

            </v-slide-x-reverse-transition>
            <p v-if="$store.getters['chat/getMessageByContract'](contract_id).length<1" class="text-xs-center white--text">Keine Einträge gefunden</p>
        </v-timeline>
        </div>

        <v-container id="inputino" class="pb-5">
            <v-layout row wrap>

                <v-flex xs12>

                    <v-text-field v-model="input_value" label="Nachricht verfassen ..." hint="Haben Sie Fragen? Möchten Sie etwas beantragen? ~ Dokumente zusenden? .. Schreiben Sie uns einfach!" solo clearable @keyup.enter="addMessage">
                        <template slot="prepend">
                            <v-speed-dial v-model="fab" direction="top" transition="slide-y-reverse-transition">
                                <template slot="activator">
                                    <v-btn v-model="fab" fab>
                                        <v-icon>attach_file</v-icon>
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </template>
                                <v-btn fab small color="grey lighten-5" class="cameraphoto-btn" @click="$refs.cameraUploadInput.click()">
                                    <v-tooltip nudge-right="10" right>
                                        <template slot="activator">
                                            <v-icon>photo_camera</v-icon>
                                        </template>
                                        <span>Bild aufnehmen</span>
                                    </v-tooltip>
                                </v-btn>
                                <v-btn fab dark small color="grey" @click="$refs.photoUploadInput.click()">
                                    <v-tooltip nudge-right="10" right>
                                        <template slot="activator">
                                            <v-icon>photo_library</v-icon>
                                        </template>
                                        <span>Bild hochladen</span>
                                    </v-tooltip>
                                </v-btn>
                                <v-btn fab dark small color="grey darken-3" @click="$refs.docUploadInput.click()">
                                    <v-tooltip nudge-right="10" right>
                                        <template slot="activator">
                                            <v-icon>insert_drive_file</v-icon>
                                        </template>
                                        <span>Dokument hochladen</span>
                                    </v-tooltip>
                                </v-btn>
                                <v-btn v-if="audioContext" fab dark small color="black" @mousedown="recordVoiceMessage" @mouseup="stopRecordVoiceMessage">
                                    <v-tooltip v-if="!is_recording" nudge-right="10" right>
                                        <template slot="activator">
                                            <v-icon>mic</v-icon>
                                        </template>
                                        <span>Sprachnachricht aufnehmen</span>
                                    </v-tooltip>
                                    <v-tooltip v-else nudge-right="10" right>
                                        <template slot="activator">
                                            <v-icon color="red">stop</v-icon>
                                        </template>
                                        <span>Aufnahme stoppen</span>
                                    </v-tooltip>
                                </v-btn>
                            </v-speed-dial>
                        </template>
                        <template slot="append">
                            <v-menu offset-y>
                                <template slot="activator">
                                    <v-icon>sentiment_satisfied_alt</v-icon>
                                </template>
                                <v-list>
                                    <v-list-tile v-for="(item, index) in smileys" :key="index" @click="addSmileyToMassage(item)">
                                        <v-list-tile-title>{{ item }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </template>
                        <template slot="append-outer">
                            <v-icon @click="addMessage">send</v-icon>
                        </template>
                    </v-text-field>

                </v-flex>


                <v-flex xs12>
                    <input type="file" ref="photoUploadInput" @change="onFileChanged" accept="image/*" hidden />
                    <input type="file" ref="cameraUploadInput" @change="onFileChanged" accept="image/*" capture="camera" hidden />
                    <input type="file" ref="docUploadInput" @change="onFileChanged" accept="application/pdf" hidden />
                </v-flex>
            </v-layout>

            <v-dialog v-model="message_modal_show" width="968">
                <v-card>
                    <v-card-text>
                        <div>
                            <v-img v-if="message_modal_item.file_type=='image'" :src="message_modal_item.file_url" alt="Bild nicht aufrufbar" contain></v-img>
                            <object v-if="message_modal_item.file_type=='pdf'" :data="message_modal_item.file_url" type="application/pdf" class="pdfpreview">
                                <iframe :src="message_modal_item.file_url" class="pdfpreview" id="pdfpreview_iframe">
                                    <p>Wir können Dir auf diesem Gerät keine PDFs anzeigen; bitte die Datei stattdessen herunterladen: <a :href="message_modal_item.file_url" target="_blank" download>PDF herunterladen</a>.</p>
                                </iframe>
                            </object>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
        
    </div>
</template>


<script>
import ProfilAvatar from '@/components/ProfilAvatar'
var lastday = {};

export default {
    name: 'chatTimeline',

    data: () => ({
            message: null,
            input_value: '',

            smileys: ['😅', '😋', '😎', '😫', '👍', '🙈', '❤️', '💯', '✔️'],
            fab: false,
            selectedFile: null,
            selectedFile_url: '',
            // selectedFile_name: '',
            selectedFile_type: '',
            gumStream: null,
            recStream: null,
            is_recording: false,

            message_modal_show: false,
            message_modal_item: {}
        }
    ),

    components: {
        ProfilAvatar
    },

    props: ['contract_id'],

    watch: {
        contract_id: function(){
            this.$store.dispatch('chat/markMassagesAsReaded', this.contract_id);
            lastday = {};
        }
    },

    computed: {
        audioContext(){
            return window.AudioContext || window.webkitAudioContext || false;
        }
    },

    created: function(){
        this.$store.dispatch('chat/markMassagesAsReaded', this.contract_id);
    },

    methods: {
        sendRecordVoiceMessage(blob) {
            //const file = event.target.files[0];
            this.selectedFile = blob;
            this.selectedFile_url = '#!';
            this.selectedFile_type = 'wav';
            this.selectedFile.name = new Date().toISOString() + '.wav';
            this.addMessage();
        },

        getWorkerPicture(sender_name){
            switch (sender_name) {
                case 'pb':
                case 'pm':
                    return require('@/assets/images/Pat-Menschner.webp');
                case 'do':
                case 'ds':
                    return require('@/assets/images/David-Salaw.webp');
                case 'mb':
                    return require('@/assets/images/Martin-Butters.webp');
                case 'jw':
                    return require('@/assets/images/Joerg-Wienbreyer.webp');
                case 'sd':
                    return require('@/assets/images/Salih-Daglar.webp');
                case 'is':
                    return require('@/assets/images/Ivonna-Strehl.webp');
                case 'AI':
                case 'ai':
                    return require('@/assets/images/Finia.webp');
                default:
                    return require('@/assets/images/Ines-Franken.webp');
            }
        },

        getWorkerName(sender_name){
            switch (sender_name) {
                case 'pb':
                    return 'Pat Menschner';
                case 'do':
                case 'ds':
                    return 'David Salaw';
                case 'mb':
                    return 'Martin Butters';
                case 'jw':
                    return 'Jörg Wienbreyer';
                case 'sd':
                    return 'Salih Daglar';
                case 'is':
                    return 'Ivonna Strehl';
                case 'ai':
                    return 'Finia';
                default:
                    return 'Ines Franken';
            }
        },
        
        onFileChanged (event) {
            const file = event.target.files[0];
            // this.selectedFile_name = file.name;
            if(file.type.search("image")<0){
                //console.log(file);
                if(file.type == "application/pdf"){
                    this.selectedFile = file;
                    this.selectedFile_url = '!#';
                    this.selectedFile_type = 'pdf';
                    this.addMessage();
                }else{
                    this.$snotify.success('Der Dateityp wird zZt. nicht unterstützt!', 'Warning');
                }
            }else{
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.addEventListener('load', () => {
                    this.selectedFile_url = fileReader.result;
                    this.selectedFile_type = 'image';
                    this.addMessage();
                });
                this.selectedFile = file;
            }
        },

        getInfoModal(message){
            if(message.file_type=='image' || message.file_type=='pdf'){
                this.message_modal_item = message;
                this.message_modal_show = true;
            }
        },

        addSmileyToMassage(smiley){
            this.input_value += smiley;
        },

        isAnotherDay(date, contract_id){
            if(date){
                date = date.split(' ')[0];
                if(!lastday[contract_id]){
                    lastday[contract_id] = date;
                    return true
                }
                if(lastday[contract_id] !== date){
                    lastday[contract_id] = date;
                    return true;
                }
            }
            return false;
        },

        getFormatedDate(date){
            // date = this.$moment(date);
            // if(this.$moment().diff(date, 'days')==0){
            //     return 'Heute';
            // }
            return this.$moment(date).format('DD.MM.YYYY').toString();
        },

        addMessage(){
            if(this.input_value.length>0 || (this.selectedFile)){
                let message = {
                    content: this.input_value,
                    contract_id: this.contract_id,
                    file: this.selectedFile,
                    file_url: this.selectedFile_url,
                    file_type: this.selectedFile_type,
                    sender: 'user',
                    type: 'message',
                    is_readed: false
                };
                this.$store.dispatch('chat/addUserChatMessage', message);
                this.input_value = '';
                this.selectedFile_url = '';
                this.selectedFile_type = '';
                this.selectedFile = null;
            }
        },

        recordVoiceMessage: function(e){
            this.is_recording = true;
            navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then((stream) => {
                if(this.audioContext!==false){
                    var ac = new AudioContext();
                    this.gumStream = stream;
                    var input = ac.createMediaStreamSource(stream);
                    this.recStream = new Recorder(input, {numChannels:1} );
                    this.recStream.record();
                };
            }).catch((err) => {
                if(err.name=='NotFoundError' || err.name=='DevicesNotFoundError'){
                    this.$snotify.error('Mikrofon konnte nicht gefunden werden. Bitte anschließen um Funktion zu nutzen.');
                }else if(err.name=='NotAllowedError' || err.name=='PermissionDeniedError'){
                    this.$snotify.error('Sie haben VAPP keinen Zugriff auf Ihr Mikrofon gestattet. Bitte korregieren.');
                }else{
                    this.$snotify.error(err, 'Unbekannter Fehler');
                    console.error('Unbekannter Fehler', err);
                };
                this.is_recording = false;
            });
        },

        stopRecordVoiceMessage: function(e){
            this.is_recording = false;
            this.recStream.stop();
            this.gumStream.getAudioTracks()[0].stop();
            this.recStream.exportWAV(this.sendRecordVoiceMessage);
        }
    }
    
}
</script>

<style>
    .v-timeline-item>.v-timeline-item__body>*>span, .v-timeline-item>.v-timeline-item__opposite>*>span{
        color:#fff;
    }
    .divider.v-timeline-item, .v-timeline-item.divider:nth-child(2n+1):not(.v-timeline-item--right), .divider.v-timeline-item--left{
        flex-direction: row;
        -webkit-box-direction: inherit;
    }
    .divider .v-timeline-item__body{
        left: calc(25% + 24px);
        text-align: center;
    }
    .v-badge--overlap .v-badge__badge {
        top: -5px;
    }
    .theme--light.v-chip .v-chip__content{
        color: #212121;
    }

    #inputino .v-input__prepend-outer{
        margin-top:0!important;
    }
    #inputino .v-input__prepend-outer>.v-speed-dial>.v-btn--floating{
        margin-top:-5px!important;
    }
    #inputino .v-speed-dial__list{
        margin-bottom: 10px;
    }
    .v-btn--floating .v-btn__content > :not(:only-child):last-child, .v-btn--floating .v-btn__content > :not(:only-child):first-child{
        line-height: 56px;
    }

    #timelino{
        height: calc(-315px + 100vh + 3rem);
        overflow-y: auto;
        padding: 0px 1rem;
        scroll-behavior: smooth;
    }
    #timelino .v-timeline-item--left .theme--light.v-sheet{
        background-color: #efefef;
        color: #000;
    }
    #timelino .v-timeline-item.v-timeline-item--left .v-card::after {
        border-right-color: #efefef;
    }
    #timelino .v-timeline-item .v-card ul{
        padding-inline-start: 0;
    }
    #timelino .v-timeline-item .v-card ul>li{
        list-style-position: inside;
    }
    #timelino .v-timeline::before {
        background: #fff;
    }
    .chatlink-box{
        width: 3.5rem;
        position: absolute;
        top: 0px;
        right: 0px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: .5rem;
    }
    .v-timeline-item__body:hover .chatlink-box{
        background-color: #025dab1a;
    }
    .v-text-field--solo .v-input__control .v-text-field__details .v-messages__wrapper{
        color:#fff;
    }

    @media screen and (max-width: 960px) {
        #timelino{
            height: calc(100vh - 250px);
        }
        #timelino .v-timeline-item{
            flex-direction: column;
        }
        #timelino .v-timeline-item > .v-timeline-item__dot--large {
            display: block;
            position: relative;
            left: inherit;
            /*transform: translateX(calc(50vw - 52px - 18px));*/
            margin-bottom: 5px;
        }
        #timelino .v-timeline-item__dot--small, #timelino .v-timeline-item__opposite, #timelino .v-timeline::before {
            display:none;
        }
        #timelino .v-timeline-item.v-timeline-item--left .v-timeline-item__body, #timelino .v-timeline-item.v-timeline-item--right .v-timeline-item__body {
            max-width: 100%;
        }
        #timelino .v-input.v-text-field .v-messages__wrapper{
            display:none;
        }
        #timelino .v-timeline-item.v-timeline-item--left .v-timeline-item__dot{
            align-self: flex-end;
        }
        #timelino .v-timeline-item.v-timeline-item--right .v-timeline-item__dot{
            align-self: flex-start;
        }
        #inputino .v-input .v-text-field__details{
            display: none;
        }
        #timelino .v-timeline-item__inner-dot .v-avatar::before{
            content: attr(title) ;
            position:absolute;
            font-size: 1rem;
            width: calc(100vw - 205px);
            left: 65px;
            color: #fff;
            text-align: left;
        }
        #timelino .v-timeline-item--left .v-timeline-item__inner-dot .v-avatar::before{
            left: inherit;
            right: 65px;
            text-align: right;
        }
        #inputino .v-input .v-input__prepend-outer{
            margin-left: -15px;
            margin-right: 0;
        }
    }
</style>